<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { ref } from 'vue';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import { useAlert } from 'dashboard/composables';
import { supportTemplates } from '../utils/dutySupportTemplates';

// Biblioteca de respostas prontas TP/CX (SPEC 28 / P37-1).
const supportTemplateCopied = ref('');

const copySupportTemplate = async template => {
  try {
    await navigator.clipboard.writeText(template.body);
    supportTemplateCopied.value = template.id;
    useAlert('Resposta copiada.');
    window.setTimeout(() => {
      supportTemplateCopied.value = '';
    }, 1800);
  } catch {
    useAlert('Não foi possível copiar a resposta.');
  }
};
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Suporte TP/CX">
    <div class="grid gap-3">
      <article
        v-for="template in supportTemplates"
        :key="template.id"
        class="rounded-lais border border-lais-border-soft bg-white p-3"
      >
        <div class="flex items-start justify-between gap-3">
          <div>
            <p class="text-[12px] font-semibold text-lais-primary">
              {{ template.group }}
            </p>
            <p class="text-[14px] font-semibold text-lais-text">
              {{ template.title }}
            </p>
          </div>
          <LaisPrimaryButton
            variant="ghost"
            icon="i-lucide-copy"
            size="sm"
            @click="copySupportTemplate(template)"
          >
            {{ supportTemplateCopied === template.id ? 'Copiado' : 'Copiar' }}
          </LaisPrimaryButton>
        </div>
        <p class="mt-3 text-[13px] leading-relaxed text-lais-text-body">
          {{ template.body }}
        </p>
      </article>
    </div>
  </LaisCard>
</template>
